import { __awaiter } from "tslib";
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ReducerType } from '../types';
import { MISSING_CUSTOMER } from '@open-tender/types';
import { checkAuth, selectToken } from './account';
const initialState = {
    entities: [],
    error: null,
    loading: 'idle',
    lookup: {}
};
export var CustomerRewardsActionType;
(function (CustomerRewardsActionType) {
    CustomerRewardsActionType["FetchCustomerRewards"] = "customer/fetchCustomerRewards";
})(CustomerRewardsActionType || (CustomerRewardsActionType = {}));
export const fetchCustomerRewards = createAsyncThunk(CustomerRewardsActionType.FetchCustomerRewards, (_, { dispatch, getState, rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const api = getState().config.api;
        const token = selectToken(getState());
        if (!token)
            throw new Error(MISSING_CUSTOMER);
        const rewards = yield api.getCustomerRewards(token);
        return rewards;
    }
    catch (err) {
        const error = err;
        return checkAuth(error, dispatch, () => rejectWithValue(error));
    }
}));
const customerRewardsSlice = createSlice({
    name: ReducerType.Rewards,
    initialState,
    reducers: {
        resetCustomerRewards: () => initialState,
        resetCustomerRewardsError: state => {
            state.error = null;
            state.loading = 'idle';
        },
        setCustomerRewards: (state, action) => {
            state.entities = action.payload;
            state.error = null;
        }
    },
    extraReducers: builder => {
        builder
            .addCase(fetchCustomerRewards.fulfilled, (state, action) => {
            state.entities = action.payload;
            state.loading = 'idle';
            state.error = null;
        })
            .addCase(fetchCustomerRewards.pending, state => {
            state.loading = 'pending';
        })
            .addCase(fetchCustomerRewards.rejected, (state, action) => {
            state.error = action.payload;
            state.loading = 'idle';
        });
    }
});
export const { resetCustomerRewards, resetCustomerRewardsError, setCustomerRewards } = customerRewardsSlice.actions;
export const selectCustomerRewards = (state) => state.customer.rewards;
export const customerRewardsReducer = customerRewardsSlice.reducer;
